import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";

const BlockedDaysPopup = (props) => {
	const [selectedDates, setSelectedDates] = useState([]);

	useEffect(() => {
		if (props.blocked_dates && props.blocked_dates.length > 0) {
			const parsedDates = props.blocked_dates.map((date) => new Date(date));
			setSelectedDates(parsedDates);
		}
	}, [props.blocked_dates]);

	const handleDateChange = (date) => {
		if (date) {
			const dateString = moment(date).format("YYYY-MM-DD");
			const existingIndex = selectedDates.findIndex(
				(d) => moment(d).format("YYYY-MM-DD") === dateString
			);

			if (existingIndex >= 0) {
				const newDates = [...selectedDates];
				newDates.splice(existingIndex, 1);
				setSelectedDates(newDates);
			} else {
				setSelectedDates([...selectedDates, date]);
			}
		}
	};

	const handleSubmit = () => {
		const formattedDates = selectedDates.map((date) =>
			moment(date).format("YYYY-MM-DD")
		);
		props.submitModal(formattedDates);
	};

	const isDateSelected = (date) => {
		return selectedDates.some(
			(selectedDate) =>
				moment(selectedDate).format("YYYY-MM-DD") ===
				moment(date).format("YYYY-MM-DD")
		);
	};

	const highlightDates = selectedDates.map((date) => new Date(date));

	const minDate = new Date();
	const maxDate = new Date();
	maxDate.setMonth(maxDate.getMonth() + 4);

	return (
		<div>
			<React.Fragment>
				<div className="modal-backdrop bg-black opacity6" />
				<div className="modal modal__publish-status d-flex align-items-center modal--overflow">
					<div
						className="modal-dialog"
						style={{ maxWidth: "650px", width: "95%" }}
					>
						<div
							className="modal-content"
							style={{
								maxHeight: "90vh",
								display: "flex",
								flexDirection: "column",
							}}
						>
							{/* Fixed Header */}
							<div
								className="modal-header border-bottom p-3"
								style={{
									position: "sticky",
									top: 0,
									backgroundColor: "white",
									zIndex: 10,
								}}
							>
								<h5 className="modal-title">Block Certain Days</h5>
								<button
									onClick={props.cancelModal}
									type="button"
									className="close"
									data-dismiss="modal"
									aria-label="Close"
								>
									<span aria-hidden="true">&times;</span>
								</button>
							</div>

							{/* Scrollable Body */}
							<div
								className="modal-body"
								style={{
									overflowY: "auto",
									flex: "1 1 auto",
									padding: "15px",
								}}
							>
								<p className="text-muted mb-3 text-center">
									Click on dates to select or deselect them. Selected dates
									will be blocked for reservations.
								</p>

								<div
									style={{
										display: "flex",
										justifyContent: "center",
									}}
								>
									<DatePicker
										inline
										monthsShown={2}
										minDate={minDate}
										maxDate={maxDate}
										selected={null}
										openToDate={minDate}
										onChange={handleDateChange}
										highlightDates={highlightDates}
										shouldCloseOnSelect={false}
										dayClassName={(date) =>
											isDateSelected(date) ? "blocked-day-selected" : undefined
										}
									/>
								</div>

								{selectedDates.length > 0 && (
									<div className="mt-3">
										<h6>Selected dates ({selectedDates.length}):</h6>
										<div
											style={{
												maxHeight: "120px",
												overflowY: "auto",
												padding: "10px",
												backgroundColor: "#f8f9fa",
												borderRadius: "4px",
												border: "1px solid #dee2e6",
											}}
										>
											{selectedDates
												.sort((a, b) => new Date(a) - new Date(b))
												.map((date, index) => (
													<span
														key={index}
														className="badge badge-danger mr-1 mb-1"
														style={{ cursor: "pointer" }}
														onClick={() => handleDateChange(date)}
													>
														{moment(date).format("DD-MM-YYYY")} &times;
													</span>
												))}
										</div>
									</div>
								)}
							</div>

							{/* Fixed Footer */}
							<div
								className="modal-footer justify-content-center border-top"
								style={{
									position: "sticky",
									bottom: 0,
									backgroundColor: "white",
									zIndex: 10,
									padding: "15px",
								}}
							>
								<button
									type="button"
									className="button--warning no-border-button bootstrap-buttons---btn bootstrap-buttons---btn-md bootstrap-buttons---btn-default"
									style={{ width: "55px !important", height: "30px !important", padding: "0" }}
									data-dismiss="modal"
									onClick={props.cancelModal}
								>
									Cancel
								</button>
								<button
									type="button"
									className="button-success--modal"
									// style={{ width: "55px", height: "30px", padding: "0" }}
									onClick={handleSubmit}
								>
									Save
								</button>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
			<style>
				{`
					.blocked-day-selected {
						background-color: #dc3545 !important;
						color: white !important;
						border-radius: 50%;
					}
					.blocked-day-selected:hover {
						background-color: #c82333 !important;
					}
					.react-datepicker__day--highlighted {
						background-color: #dc3545 !important;
						color: white !important;
						border-radius: 50%;
					}
					.react-datepicker {
						display: flex !important;
						flex-direction: row !important;
					}
					.react-datepicker__month-container {
						float: none !important;
						display: inline-block;
					}
				`}
			</style>
		</div>
	);
};

export default BlockedDaysPopup;